
import { Button, Grid, TextareaAutosize, Typography } from "@mui/material";
import GenericModal from "../GenericModal";
import { Vocabulary } from "../../Utils/Vocabulary";
import SaveIcon from "@mui/icons-material/Save";
import genericStyles from "../../Styles/genericStyles.module.css";

interface OCRTokenSettingsProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
  data: { ocrToken: string; } | null;
  setData: (data: { ocrToken: string; }) => void;
}

const OcrTokenOptions = (onClose: any, handleSubmit: any) => {
  return (<div className={genericStyles.modalActions}>
    <Button color="error" variant="outlined" fullWidth onClick={onClose}>
      {Vocabulary.cancel}
    </Button>
    <Button
      fullWidth
      onClick={handleSubmit}
      variant="contained"
      startIcon={<SaveIcon />}
    >
      {Vocabulary.save}
    </Button>
  </div>);
};

export default function OCRTokenSettings(props: OCRTokenSettingsProps) {

  return (
    <GenericModal
      open={props.isOpen}
      onClose={props.onClose}
      title={Vocabulary.tokenOCR}
      actions={OcrTokenOptions(props.onClose, props.onSubmit)}
    >
      {/* OCR Token Section */}
      <Grid container spacing={3}  >
        <Grid item xs={12}>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
            {Vocabulary.tokenOCRDescription}
          </Typography>
        </Grid>
        <Grid item xs={12}>

          <TextareaAutosize
            aria-label="exam questions"
            placeholder={Vocabulary.addToken}
            value={props.data?.ocrToken || ""}
            style={{
              width: '100%',
              minHeight: 200,
              fontFamily: 'inherit',
              padding: '8px',
              borderRadius: '4px',
              border: '1px solid #ccc',
              resize: 'vertical'
            }}
            onChange={(e) => props.setData({
              ocrToken: e.target.value,
            })}
          />
        </Grid>
      </Grid>
    </GenericModal>
  );
}
